import * as React from 'react';
import { Block } from '../../../../commonv3/types/block';
import { BlockContentPane } from './BlockContentPane';
import './blockPane.module.scss';

type Props = {
    index: number;
    block: Block;
};

export class BlockPane extends React.Component<Props> {
    render() {
        const { block, index } = this.props;
        const { block_type, content } = block;
        return (
            <div styleName="block-pane">
                <div styleName="title">
                    {index + 1}. {block.title}
                </div>
                <BlockContentPane blockType={block_type} content={JSON.parse(content)} />
            </div>
        );
    }
}
